import React from 'react'
import styles from '../../tabs/review/RequestForReviews/RequestForReviews.module.scss'
import ReviewsRequestsListItem from './ReviewsRequestsListItem'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

function ReviewsRequestsList({ requests, filter, handleScroll, loading }) {
  return (
    <>
      <div className={styles.requestCardsContainer} onScroll={handleScroll}>
        <div className={styles.masonryWrapper}>
          <ResponsiveMasonry columnsCountBreakPoints={{ 0: 1, 1200: 2 }}>
            <Masonry gutter='var(--masonry-gutter)'>
              {requests
                .filter((item) => filter === 'all' || item.category.toLowerCase() === filter.toLowerCase())
                .map((item) => (
                  <ReviewsRequestsListItem data={item} key={item.id} filter={filter} />
                ))}
              {loading && requests.length > 0 && (
                <>
                  <div className={styles.requestSkeletonItem}>
                    <div className={styles.requestSkeletonHeader}>
                      <div className={styles.requestSkeletonPhoto} />
                      <div className={styles.requestSkeletonInfo}>
                        <div className={styles.requestSkeletonPrompt} />
                        <div className={styles.requestSkeletonName} />
                        <div className={styles.requestSkeletonRank} />
                        <div className={styles.requestSkeletonVessel} />
                      </div>
                    </div>
                  </div>
                  <div className={styles.requestSkeletonItem}>
                    <div className={styles.requestSkeletonHeader}>
                      <div className={styles.requestSkeletonPhoto} />
                      <div className={styles.requestSkeletonInfo}>
                        <div className={styles.requestSkeletonPrompt} />
                        <div className={styles.requestSkeletonName} />
                        <div className={styles.requestSkeletonRank} />
                        <div className={styles.requestSkeletonVessel} />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    </>
  )
}

export default ReviewsRequestsList
